<template>
  <header
    v-if="isMaterial && data"
    id="card-material"
    :class="[
      'flex justify-between gap-3 p-5 border-b cursor-pointer hover:opacity-75',
      storeMaterial.currentMaterial?.id === data.id ? 'bg-gray-50' : 'bg-white',
    ]"
    @click="storeMaterial.selectMaterial(index!)"
  >
    <p class="line-clamp-2 ml-8" :title="data.name">
      {{ data.name }}
    </p>
    <small
      v-if="data.done"
      class="px-2 py-1 bg-green-500 text-white rounded-lg border h-fit"
    >
      {{ "Concluído" }}
    </small>
  </header>

  <header
    v-if="isTrail && data"
    class="flex justify-between items-center w-full ml-3"
  >
    <div class="flex gap-2 items-center">
      <v-icon
        name="hi-solid-check-circle"
        :class="[statusColor(), 'w-5 h-5']"
      />

      <p class="line-clamp-2" :title="data.name">
        {{ data.name }}
      </p>
    </div>
    <div class="flex items-center gap-2">
      <i
        :class="[
          storeTrail.currentTrail === data
            ? 'pi pi-angle-up'
            : 'pi pi-angle-down',
        ]"
      />
    </div>
  </header>
</template>

<script lang="ts">
import { useMaterialStore } from "@/store/linear/material";
import { useTrailStore } from "@/store/linear/trail";
import { defineComponent } from "vue";

export default defineComponent({
  name: "ButtonAccordion",
  setup(props) {
    const storeMaterial = useMaterialStore;
    const storeTrail = useTrailStore;

    function statusColor(): string {
      if (props.data?.done) return "text-h-success-500";
      else return "text-h-neutral-400";
    }

    return { statusColor, storeMaterial, storeTrail };
  },
  props: {
    data: Object,
    index: Number,
    isMaterial: Boolean,
    isTrail: Boolean,
  },
});
</script>
